<template>
  <div class="input-radio">
    <label :id="id">
      {{ text }}
      <input
        :id="id"
        v-model="tempName"
        :name="name"
        :value="value"
        type="radio"
        :required="required"
      />
    </label>
  </div>
</template>

<script>
export default {
  name: 'input-radio',
  props: {
    required: {
      default: false,
      type: Boolean
    },
    name: {
      default: 'noName',
      type: String
    },
    text: {
      default: 'No Text',
      type: String
    },
    value: {
      default: null,
      type: String
    }
  },
  data() {
    return {
      id: new Date().getTime(),
      tempName: ''
    }
  },
  created() {
    this.tempName = this.name
  },
  updated() {
    this.$emit('model', this.value)
  }
}
</script>

<style lang="scss" scoped>
.input-radio {
}
</style>
